var _style, _line, _line2, _line3, _line4, _rect, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluidActuator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6.1,
    y1: 8,
    x2: 7.5,
    y2: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.2,
    y1: 8,
    x2: 10,
    y2: 8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11.1,
    y1: 8,
    x2: 12.9,
    y2: 8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13.8,
    y1: 8,
    x2: 15.6,
    y2: 8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 5.2,
    className: "st0",
    width: 5.7,
    height: 5.6
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6.3,
    y1: 5.2,
    x2: 9.1,
    y2: 5.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluidActuator);
export default __webpack_public_path__ + "static/media/FluidActuator.5cc49e141f8d67e22ba975c58b99ca80.svg";
export { ForwardRef as ReactComponent };